/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/ActiveAction/StatusUpdate/Content/SectionText/Content"
  
}) {
let constantData = 'Change treatment status for'
let personValueData = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromFormat.personName,
})
let aggregateData = fromAggregate.join(constantData, personValueData)
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="xmedium"
 weight="semibold"
 marginBottom={dtSpaceM}
 marginTop={dtSpaceM}
 data="'Change treatment status for'"
 data="person"
 format="/Data/format.js personName"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}